module.exports = __webpack_public_path__ + "img/u158.406d522.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/figma/u158.png
// module id = i+Ow
// module chunks = 0